import { genericPage, getServerSidePropsHelper } from 'components/3catinfo/Page';
import { useRouter } from 'next/router';

let basePath = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'atencio', 'com-veure-i-escoltar', 'mobils-i-tauletes'];
let path = basePath;

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    let layoutName = 'app';

    switch (slug) {
        case 'app-catalunya-radio':
        case 'app-crims-casos-oberts':
        case 'app-esport3':
            layoutName = slug;
            break;
        case 'app-3cat':
        case 'app-3catinfo':
        case 'app-icat':
        case 'app-sx3':
            break;
        default:
            return {
                notFound: true
            };
    }

    path = [...basePath, layoutName];

    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
